// extracted by mini-css-extract-plugin
export default {"btnWrapper":"btnWrapper__512GV"};